var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("This is an about page")]),_c('Shapechanger',{staticStyle:{"width":"50%"},attrs:{"original":"/assets/img/mira.png","interim":"/assets/img/dopplemira.png","shifted":"/assets/img/nix.png"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }